import { AtSignIcon, Button, EmptyState } from '@buffer-mono/popcorn'

import { openInstagramFacebookReAuthModal } from '../../util/instagramFacebookReAuth'

import styles from './MentionsInstagramLoginEmptyState.module.css'

import type { JSX } from 'react'
import { useHasOrganizationAction } from '~publish/contexts/AccountContext'

export type MentionsInstagramLoginEmptyStateChannel = {
  id: string
  type: string
}

type MentionsInstagramLoginEmptyStateProps = {
  channel: MentionsInstagramLoginEmptyStateChannel
}

/**
 * Stands in for the mentions feed on an Instagram channel connected through
 * Instagram login, which never receives mentions, and offers the switch to a
 * Facebook Page. Comments work on either login.
 */
export function MentionsInstagramLoginEmptyState({
  channel,
}: MentionsInstagramLoginEmptyStateProps): JSX.Element {
  const canManageChannels = useHasOrganizationAction('manageChannels')

  return (
    <div className={styles.layoutWrapper}>
      <EmptyState size="large">
        <EmptyState.Icon>
          <AtSignIcon />
        </EmptyState.Icon>
        <EmptyState.Heading>
          Unlock mentions for this channel
        </EmptyState.Heading>
        <EmptyState.Description>
          To access Instagram mentions, link your Instagram account to a
          Facebook Page.
        </EmptyState.Description>
        {canManageChannels && (
          <EmptyState.Actions>
            <Button
              onClick={(): void => openInstagramFacebookReAuthModal(channel)}
            >
              Link Account to Facebook Page
            </Button>
          </EmptyState.Actions>
        )}
      </EmptyState>
    </div>
  )
}
